// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"214":"polyfills-core-js","748":"polyfills-dom"}[chunkId] || chunkId) + "." + {"214":"28380e16","370":"66825a1c","376":"8587601a","405":"f11004f1","482":"1c2897c4","748":"09db86da"}[chunkId] + ".chunk.js";
};